// extracted by mini-css-extract-plugin
export default {"planet":"Planet_planet__sTvYG","table":"Planet_table__V49Zf","feature":"Planet_feature__hAlmq"};